/**
 * JourneyAvatar — single source of truth for Journey's face/identity.
 *
 * Always renders a circular crop of her portrait. Picks the smallest
 * pre-rendered file that comfortably exceeds the requested size, so we
 * don't ship a 1.9MB 1122x1402 PNG to a 32px avatar slot.
 *
 * Sizes are tuned to match where she currently appears:
 *  - 32  : chat message avatar / typing indicator
 *  - 36  : sidebar header
 *  - 64+ : empty-state hero
 *  - 128+: profile / "what do you look like" reveal
 */

const PORTRAIT_BY_SIZE = [
  { max: 80, src: "/journey-avatar-128.png" },
  { max: 200, src: "/journey-avatar-256.png" },
  { max: 480, src: "/journey-avatar-512.png" },
];

function pickSrc(size) {
  for (const tier of PORTRAIT_BY_SIZE) {
    if (size <= tier.max) return tier.src;
  }
  return "/journey-avatar.png";
}

export default function JourneyAvatar({
  size = 36,
  className = "",
  ringed = true,
  testId = "journey-avatar",
}) {
  const px = `${size}px`;
  const ringClass = ringed
    ? "ring-1 ring-cyan-400/30 ring-offset-1 ring-offset-[#0a0a0a]"
    : "";
  return (
    <img
      src={pickSrc(size)}
      alt="Journey"
      width={size}
      height={size}
      className={`rounded-full object-cover bg-cyan-500/10 ${ringClass} ${className}`}
      style={{ width: px, height: px }}
      data-testid={testId}
      draggable={false}
    />
  );
}
